import React from 'react';

import Tracked from '~/components/Tracked';
import type { SubMenuProps } from '~/legacy/types';
import { bem, logoIcons } from '~/legacy/utils';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import ColourCheckbox from '../ColourCheckbox';
import { AngleRight } from './MainHeaderMobile';

const SubMenu = ({
  selected = null,
  parentName,
  closeMenu,
  selectItem,
  menu,
  idsStack,
  path,
  nestingLevel = 1
}: SubMenuProps) => {
  const isExpanded =
    !!idsStack.find((x) => x.name === parentName) &&
    selected?.name !== parentName;
  const menuTypes = ['filter', 'label'];
  const initialOffset = 370;
  const listStyle =
    !!selected && selected.name === parentName
      ? {
          left: `${nestingLevel * initialOffset}px`
        }
      : undefined;

  return (
    <ul
      className={bem('main-header-mobile__menu-list', {
        expanded: isExpanded,
        show: !!selected && selected.name === parentName
      })}
      style={listStyle}
    >
      {menu.map((menuItem, index: number) => (
        <React.Fragment key={`${parentName}-${menuItem.name}-${index}`}>
          {menuItem.type === 'filter' && (
            <li
              className="main-header-mobile__menu-list-item"
              onClick={closeMenu}
            >
              <Tracked.ExternalLink
                className="main-header-mobile__link main-header-mobile__link--secondary"
                name={menuItem.name as TrackedButtonClickName}
                href={menuItem.link || ''}
                variant="none"
                pagePosition="Header"
              >
                {menuItem.name}
              </Tracked.ExternalLink>
            </li>
          )}
          {menuItem.type === 'label' && (
            <li className="main-header-mobile__menu-list-item">
              {menuItem.name}
            </li>
          )}
          {(!menuItem.children || !menuItem.children.length) &&
            !menuTypes.includes(menuItem.type) && (
              <li
                className="main-header-mobile__menu-list-item"
                onClick={closeMenu}
              >
                {menuItem.colour && (
                  <div style={{ marginRight: '10px', marginTop: '5px' }}>
                    <ColourCheckbox isRefined={false} fill={menuItem.colour} />
                  </div>
                )}

                <Tracked.ExternalLink
                  variant="none"
                  name={menuItem.name as TrackedButtonClickName}
                  pagePosition="Header"
                  className={bem('main-header-mobile__link', {
                    label: menuItem.type === 'link'
                  })}
                  href={
                    menuItem?.link ||
                    (menuItem?.slug.includes('?') &&
                      `${path}${menuItem?.slug}`) ||
                    `${path}${menuItem?.slug}/`
                  }
                >
                  {menuItem.type === 'brand' && (
                    <div className="main-header-mobile__brand-logo">
                      <img
                        alt={menuItem.name}
                        src={logoIcons[menuItem.icon]}
                        loading="lazy"
                      />
                    </div>
                  )}
                  <div className={`main-header-mobile__item-text`}>
                    {menuItem.name}
                  </div>
                </Tracked.ExternalLink>
              </li>
            )}

          {!!menuItem.children && !!menuItem.children.length && (
            <>
              <li className="main-header-mobile__menu-list-item">
                <div
                  onClick={() => selectItem(menuItem)}
                  className={`main-header-mobile__link`}
                >
                  {menuItem.type === 'brand' && (
                    <div className="main-header-mobile__brand-logo">
                      <img
                        alt={menuItem.name}
                        src={logoIcons[menuItem.icon]}
                        loading="lazy"
                      />
                    </div>
                  )}
                  <div className={`main-header-mobile__item-text`}>
                    {menuItem.name}
                  </div>
                  <span className={`main-header-mobile__menu-list-angle-right`}>
                    {!!menuItem.children.length && <AngleRight />}
                  </span>
                </div>
              </li>
              <SubMenu
                selected={selected}
                parentName={menuItem.name}
                closeMenu={closeMenu}
                selectItem={selectItem}
                menu={menuItem.children || []}
                idsStack={idsStack}
                path={menuItem.path}
                nestingLevel={nestingLevel + 1}
              />
            </>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default SubMenu;
